import React, { Component } from "react";
import LoadingAnimation from "../LoadingAnimation";
import dayjs from "dayjs";

import { fetchGET } from "../../apiHelper";

export default class NewsPage extends Component {
  state = {
    novice: [],
    loading: true,
    open: {}, // track open items by index
  };

  componentDidMount() {
    this.getNovice();
  }
  getNovice = async () => {
    try {
      const response = await fetchGET(
        `${process.env.REACT_APP_ApiDomain}` + `/api/student/rss1`
      );
      this.setState({
        novice: response,
        loading: false,
      });
    } catch (error) {
      console.log("Prišlo je do napake");
    }
  };

  toggleItem = (index) => {
    this.setState((prev) => {
      const open = { ...prev.open };
      open[index] = !open[index];
      return { open };
    });
  };

  render() {
    const { slovarBesed } = this.props;

    return (
      <>
        {/* LOADER */}

        {this.state.loading === true ? (
          <LoadingAnimation />
        ) : (
          <>
            <div
              id="news-page"
              style={{
                marginTop: "50px",
                marginBottom: "50px",
                padding: "10px",
              }}
            >
              <h3 id="NWS-1" style={{ margin: "10px 0 30px 20px" }}>
                <i className="fa fa-book" style={{ marginRight: "10px" }}></i>
                {slovarBesed["NWS-1"]?.naziv}
              </h3>

              {/* SEZNAM NOVIC */}

              <div>
                {this.state.novice.map((item, index) => (
                  <div
                    key={index}
                    className="news-item"
                    style={{
                      marginBottom: "12px",
                      border: "1px solid #d0cacaff",
                    }}
                  >
                    <div
                      className="collapsible-trigger"
                      onClick={() => this.toggleItem(index)}
                      role="button"
                      tabIndex={0}
                      style={{ cursor: "pointer", outline: "none" }}
                    >
                      <div className="news-header">
                        <span id="NWS-2">
                          {slovarBesed["NWS-2"]?.naziv}{" "}
                          {dayjs(item.datum).format("D.M.YYYY")}
                        </span>
                        <span>{item.fakulteta}</span>
                      </div>
                      <div
                        className="news-title"
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          backgroundColor: this.state.open[index]
                            ? "#def1fc"
                            : "white",
                          borderBottom: this.state.open[index]
                            ? "1px solid #d0cacaff"
                            : "none",
                          padding: "10px",
                        }}
                      >
                        <div style={{ marginRight: "12px" }}>{item.naslov}</div>
                        <i
                          className={
                            "fa fa-chevron-" +
                            (this.state.open[index] ? "up" : "down")
                          }
                        />
                      </div>
                    </div>

                    {this.state.open[index] && (
                      <div
                        className="collapsible-content"
                        style={{ marginTop: "10px" }}
                      >
                        <div style={{ paddingLeft: "10px" }}>
                          {(item.opis || "").replace(/(<([^>]+)>)/gi, "")}
                        </div>
                        <a
                          id="NWS-3"
                          href={item.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: "#1b92bb", paddingLeft: "10px" }}
                        >
                          {slovarBesed["NWS-3"]?.naziv}
                        </a>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </>
        )}
      </>
    );
  }
}
